import React from 'react';

import { cn } from '@rsc/tailwind-base/utils';
import { Button } from '@rsc/ui-components/shadcn/Button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@rsc/ui-components/shadcn/Tooltip';

const isColor = strColor => {
  if (typeof window !== 'undefined') {
    const s = new Option().style;
    s.color = strColor;
    return s.color !== '';
  }
  return false;
};

interface Props {
  handleChange: (arg: { target: { name: string; value: string } }) => void;
  option: {
    name: string;
    value: string;
    type: string;
    image: string;
  };
  selected: boolean;
  small?: boolean;
  unavailable: boolean;
}

export default function ColorSwatch({
  handleChange,
  option,
  selected = false,
  small = false,
  unavailable = false,
}: Readonly<Props>) {
  const size = small ? 'w-6 h-6' : 'w-9 h-9';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            aria-checked={selected}
            type="button"
            role="radio"
            className={cn(
              'border-border rounded-full p-0 overflow-hidden flex content-center items-center',
              size,
              selected
                ? 'outline outline-offset-2 outline-ring'
                : 'hover:border-ring hover:bg-accent'
            )}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              handleChange({
                target: {
                  name: option.name,
                  value: option.value,
                },
              });
            }}
          >
            {option.type === 'swatch_image' ? (
              <span
                style={{
                  backgroundImage: `url(${option?.image})`,
                  backgroundSize: '120%',
                }}
                className={cn(
                  'rounded-none bg-center bg-no-repeat',
                  size,
                  unavailable ? 'opacity-30' : 'opacity-100'
                )}
                title={option?.value}
              />
            ) : (
              <span
                style={{
                  background: isColor(option?.image)
                    ? option.image
                    : 'bg-border',
                }}
                className={`h-full w-full rounded-full ${
                  unavailable ? 'opacity-30' : 'opacity-100'
                }`}
                title={option.value}
              />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p className="mb-0 text-sm">{option?.value}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
